import React, { FC } from 'react';

import { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import Link from 'buyside/components/presentation/Link/link';
import RequestAccessButton from 'buyside/components/presentation/RequestAccessButton/requestAccessButton';
import SubscribeCard from 'buyside/components/presentation/SubscribePage/SubscribeCard/subscribeCard';
import SubscribeFeaturesTable from 'buyside/components/presentation/SubscribePage/SubscribeFeaturesTable/subscribeFeaturesTable';

import { stripePlans } from 'interfaces/payment/plans';

import styles from './subscribePageStyles.scss';

const SubscribePage: FC<{ isRetail: boolean }> = ({ isRetail }) => {
  const plans = isRetail ? stripePlans.retail : stripePlans.buyside;

  return (
    <div className={styles.subscribePage}>
      <img
        className={styles.subscribePageBackground}
        src="/images/pro/subscription page background.png"
        alt="Subscription Page Background"
      />
      <div className={styles.subscribePageHeader}>
        <h2>
          <strong>Access SumZero's Buyside Research</strong>
        </h2>
        <p>Join SumZero and gain access to top-quality research by professional investors</p>
      </div>
      <div className={styles.subscribePageCards}>
        {plans.map((plan, index) => (
          <ErrorBoundary key={`subscribe-card-${index}`} pageName="the checkout page">
            <SubscribeCard {...plan} />
          </ErrorBoundary>
        ))}
      </div>
      {isRetail ? (
        <div className={styles.subscribePageFeaturesTableContainer}>
          <h2>
            <strong>What You Get</strong>
          </h2>
          <SubscribeFeaturesTable />
        </div>
      ) : null}
      <div className={styles.subscribePageRequestInformation}>
        <h2>
          <strong>Need More Information?</strong>
        </h2>
        <p>
          Contact <Link to="mailto:access@sumzero.com">access@sumzero.com</Link> for any questions
          related to setting up on-going access to the SumZero research database.
        </p>
        <br />
        <RequestAccessButton text="Request More Information" type={BUTTON_TYPES.PRIMARY} />
      </div>
    </div>
  );
};

export default SubscribePage;
